import { createSlice } from '@reduxjs/toolkit';
// utils
import { ServerConfiguration } from '../../utils/serverConfig';

// ----------------------------------------------------------------------

const url = ServerConfiguration.testingServerUrl;

const initialState = {
  isLoading: false,
  error: null,
  userProfile: null,
  userProfileAction: null,
  profileImageAction: null,
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET USER PROFILE
    userProfileSuccess(state, action) {
      state.isLoading = false;
      state.userProfile = action.payload;
    },

    // UPDATE USER PROFILE
    userProfileActionSuccess(state, action) {
      state.isLoading = false;
      state.userProfile = action.payload;
      state.userProfileAction = action.payload;
    },

    // CLEAR USER PROFILE ACTIONS
    clearUserProfileActionSuccess(state, action) {
      state.isLoading = false;
      state.userProfileAction = null;
    },

    updateProfileImageSuccess(state, action) {
      state.isLoading = false;
      state.profileImageAction = action.payload;
    },

    clearUserActionSuccess(state, action) {
      state.isLoading = false;
      state.profileImageAction = null;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getUserProfile(type, typeValue, userRoleId, listPerPage, page, userId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${url}User_ProfileListByType?TYPE=${type}&TYPEVALUE=${typeValue}&USERROLEID=${userRoleId}&LISTPERPAGE=${listPerPage}&PAGE=${page}&USERID=${userId}`
      );
      const json = await response.json();
      const data = JSON.parse(json)[0];
      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.userProfileSuccess(JSON.parse(data.ReturnData)[0]));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateUserProfile(userId, firstName, lastName, contactNo, userDOB, email, gender,year) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${url}User_UpdateProfile?USERID=${userId}&FIRSTNAME=${firstName}&LASTNAME=${lastName}&USERCONTACTNO=${contactNo}&USERDOB=${userDOB}&USEREMAIL=${email}&USERGENDER=${gender}&YEARINTAKE=${year}`
      );
      const json = await response.json();
      const data = JSON.parse(json)[0];
      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.userProfileActionSuccess(JSON.parse(data.ReturnData)[0]));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function clearUserProfileAction() {
  return async (dispatch) => {
    dispatch(slice.actions.clearUserProfileActionSuccess());
  };
}

export function updateUserProfileImage(userId, type, image) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${url}User_UserUpdatePhoto?USERID=${userId}&TYPE=${type}&USERPROFILEIMAGE=${image}`
      )
      const json = await response.json();
      const data = JSON.parse(json)[0];
      if (data && data.ReturnVal === 1) {
        dispatch(getUserProfile('UserProfile', userId, 0, 999, 1, userId))
        dispatch(slice.actions.updateProfileImageSuccess(JSON.parse(data.ReturnData)));

      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function clearUserAction() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.clearUserActionSuccess([]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}